export default "__VITE_ASSET__nOHDWu9d__"